import {Component, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';
import * as routes from '@app/routes';
import {select, Store} from '@ngrx/store';
import {
  getInfluencersProjectSegment,
  getInfluencersSyncError, getInfluencersTypes,
  getLoggedInUser,
  getProject,
  getProjectError,
  getProjectSuccess,
  getProjectSuccessResponse,
  getRegistrationPlatformError,
  getRegistrationPlatformPaginated,
  getRegistrationPlatformSuccess,
  getSyncInfluencers,
  IAuthenticationState,
  IInfluencersState,
  InfluencersProjectSegment,
  InfluencersSync,
  InfluencersSyncStatus, InfluencersTypeList,
  IProjectState,
  IRegistrationPlatformState,
  ProjectGet,
  ProjectUpdate,
  RegistrationPlatformListPaginated,
  RegistrationPlatformUpdate,
  ResetAuthState,
  ResetRegistrationPlatformState,
} from '@app/stores';
import {ActivatedRoute, Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {takeUntil} from 'rxjs/operators';
import {Constants} from '@app/consts';
import {SocketService} from '@app/services/socket.service';
import {UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Observable} from 'rxjs';
import {LoaderService} from '@app/services/loader.service';
import moment from 'moment-timezone';
import {RegistrationPlatformService} from '@app/services/registration-platform.service';
import {CreatableSelectComponent} from '@app/_components/creatable-select';
import {TaskLogsComponent} from '@app/_components/task-logs/task-logs.component';
import {environment} from "@environments/environment";
import * as DataTables from 'datatables.net';

interface FieldMapping {
  label: string;
  key: string;
  value: string;
}

interface FieldMapping {
  label: string;
  key: string;
  value: string;
}

@Component({
  selector: 'app-thirdparty-platforms',
  templateUrl: './thirdparty-platforms.component.html',
  styleUrls: ['./thirdparty-platforms.component.css', './thirdparty-platforms-api-modal.css'],
  providers: [Constants]
})
export class ThirdpartyPlatformsComponent implements OnInit, OnDestroy {
  @ViewChild('logsTable', {static: true}) logsTable: TemplateRef<any>;
  unsubscriber = new Subject();
  private searchDelay: ReturnType<typeof setTimeout>;
  /** Bound to registration platform search input (server-side filter). */
  platformSearchQuery = '';
  /** After first paginated list response (avoids flashing empty state before load). */
  registrationPlatformsLoaded = false;
  private registrationPlatformsBootstrap = false;
  routes = routes;
  loader$: Observable<boolean>;
  public registrationPlatformList = [];
  deleteAction = false;
  updateAction = false;
  loginWithUser = false;
  selectedClient = 'All';
  projectId: any;
  importData: Array<Object>;
  public importJobId: number;
  public socketSubscription: any;
  public importProgress: any = {
    status: 'started',
    progress: 0
  };
  public loaderImport = new BehaviorSubject<boolean>(false);
  public loaderImport$ = this.loaderImport.asObservable();
  platformName: '';
  apiIntegrationGuide: '';
  platformId: '';
  authSwapcardForm: UntypedFormGroup;
  authLineUpNinjaForm: UntypedFormGroup;
  authSessionBoardForm: UntypedFormGroup;
  authTerrapinSalesforceForm: UntypedFormGroup;
  authMapYourShowForm: UntypedFormGroup;
  authPersonifyA2ZForm: UntypedFormGroup;
  authCadmiumForm: UntypedFormGroup;
  authCventForm: UntypedFormGroup;
  authSwoogoForm: UntypedFormGroup;
  authSwoogoSponsorsForm:UntypedFormGroup;
  authTechEventForm: UntypedFormGroup;
  authMockForm: UntypedFormGroup;
  submitted = false;
  authProjectRegistrationPlatform = {};
  savePlatformName = '';
  modelRef: any;
  currentIndex = 0;
  currentPlatform: any;
  currentSyncId = 0;
  currentSyncPlatform: any;
  isSwapcardFormValid = true;
  isLienUpNinjaFormValid = true;
  isTerrapinSalesforceFormValid = true;
  isSessionBoardFormValid = true;
  isMapYourShowFormValid = true;
  isPersonifyA2ZFormValid = true;
  isCadmiumFormValid = true;
  readonly cadmiumFilterByHelpText =
    'Optional. Leave blank to import all allowed records. To limit what syncs, enter one JSON object: a Cadmium field name and the value it must match.\n\n' +
    'Examples:\n' +
    '{ "PresenterPosition": "CEO" }\n' +
    '{ "status": "active" }';
  isSwoogoFormValid = true;
  isSwoogoSponsorsValid = true;
  isTechEventFormValid = true;
  isCventFormValid = true;
  isMockFormValid = true;
  project: any;
  currentModel: any;
  isWebHookAdd = false;
  updateProjectAction = false;
  segments: any = [];
  attendeeSegments: any = [];
  speakerSegments: any = [];
  partnerSegments: any = [];
  selectedSpeakerSegment: any = null;
  selectedAttendeeSegment: any = null;
  selectedPartnerSegment: any = null;

  selectedSalesForceSpeakerSegment: any = null;
  selectedSalesForceOtherAttendeeSegment: any = null;
  selectedSalesForceSponsorSegment: any = null;
  selectedSalesForceExhibitorSegment: any = null;
  selectedSalesForceGuestSegment: any = null;
  selectedMYSExhibitorSegment: any = null;
  selectedMYSSpeakerSegment: any = null;
  influencerTypes = [];

  isSegmentSelect = '';
  isSubmit = false;
  directCall = false;
  uniqueSyncString: any;
  apiIntegrationModelRef = null;
  importDataTableOptions: DataTables.Config = {
    ordering: false,
    processing: true,
    pagingType: 'full_numbers',
    pageLength: 10,
    paging: true,
    searching: true,
    drawCallback: function (setting) {
      const totalPages = this.api().page.info().pages;
      if (totalPages <= 1) {
        document.querySelector('.dataTables_paginate').classList.add('d-none');
      } else {
        document.querySelector('.dataTables_paginate').classList.remove('d-none');
      }
    }
  };
  currentUser: any = {};

  @ViewChild('speakerSegment') speakerSegment: CreatableSelectComponent;
  @ViewChild('attendeeSegment') attendeeSegment: CreatableSelectComponent;
  @ViewChild('partnerSegment') partnerSegment: CreatableSelectComponent;

  allFields: FieldMapping[] = [
    { key: 'platform_unique_id', label: 'Platform Unique ID', value: 'id' },
    { key: 'prefix', label: 'Prefix', value: '' },
    { key: 'suffix', label: 'Suffix', value: '' },
    { key: 'first_name', label: 'First Name', value: '' },
    { key: 'last_name', label: 'Last Name', value: '' },
    { key: 'job_title', label: 'Job Title', value: '' },
    { key: 'company', label: 'Company', value: '' },
    { key: 'email', label: 'Email', value: '' },
    { key: 'image', label: 'Image URL', value: '' },
    { key: 'description', label: 'Description / Bio', value: '' },
    { key: 'phone', label: 'Phone', value: '' },
    { key: 'booth_number', label: 'Booth Number', value: '' },
    { key: 'video_url', label: 'Video', value: '' },
    { key: 'sessions', label: 'Sessions', value: '' },
    { key: 'custom_1', label: 'Custom 1', value: '' },
    { key: 'custom_2', label: 'Custom 2', value: '' },
    { key: 'custom_3', label: 'Custom 3', value: '' },
    { key: 'custom_4', label: 'Custom 4', value: '' },
    { key: 'custom_5', label: 'Custom 5', value: '' },
    { key: 'custom_6', label: 'Custom 6', value: '' },
    { key: 'custom_7', label: 'Custom 7', value: '' },
    { key: 'custom_8', label: 'Custom 8', value: '' },
    { key: 'custom_9', label: 'Custom 9', value: '' },
    { key: 'custom_10', label: 'Custom 10', value: '' }
  ];

  // Show only these fields initially
  visibleFields: FieldMapping[] = [
    { key: 'email', label: 'Email', value: 'email' },
    { key: 'platform_unique_id', label: 'Platform Unique ID', value: 'id' },
    { key: 'first_name', label: 'First Name', value: 'first_name' },
    { key: 'last_name', label: 'Last Name', value: 'last_name' },
    { key: 'image', label: 'Image', value: 'image' },
  ];

  onFieldKeyChange(index: number): void {
    const selectedKey = this.visibleFields[index].key;
    const fieldDef = this.allFields.find(f => f.key === selectedKey);
    if (fieldDef) {
      this.visibleFields[index].label = fieldDef.label;
      this.visibleFields[index].value = fieldDef.key;
    }
  }

  isFieldDisabled(key: string): boolean {
    return this.visibleFields.some(f => f.key === key);
  }

  addEmptyField(): void {
    const firstUnused = this.allFields.find(f =>
      !this.visibleFields.some(v => v.key === f.key)
    );
    if (firstUnused) {
      this.visibleFields.push({
        key: firstUnused.key,
        label: firstUnused.label,
        value: firstUnused.key,
      });
    } else {
      this.visibleFields.push({ key: '', label: '', value: '' });
    }
  }

  removeVisibleField(index: number, field: FieldMapping): void {
    if (field.key === 'email' || field.key === 'platform_unique_id' ) {
      this.toastr.warning(`${field.key} is required field`);
    } else {
      this.visibleFields.splice(index, 1);
    }
  }

  fieldMappings: { [key: string]: string } = {};

  shareSyncLinkUrl = '';
  constructor(
    private authenticationStore: Store<IAuthenticationState>,
    private registrationPlatformStore: Store<IRegistrationPlatformState>,
    private influencersStore: Store<IInfluencersState>,
    private registrationPlatformService: RegistrationPlatformService,
    private projectStore: Store<IProjectState>,
    private authStore: Store<IAuthenticationState>,
    private router: Router,
    private toastrService: ToastrService,
    private route: ActivatedRoute,
    private loaderService: LoaderService,
    private toastr: ToastrService,
    private readonly socketService: SocketService,
    private _modalService: NgbModal,
    private formBuilder: UntypedFormBuilder,
    public constants: Constants,
  ) {
    this.socketService.resetSocketData();
    this.registrationPlatformStore.dispatch(ResetRegistrationPlatformState({params: {error: '', paginatedRegistrationPlatform: null, influencersSync: null}}));
    this.authStore.dispatch(ResetAuthState({params: {error: '', success: ''}}));
    this.route.params.subscribe(params => {
      if (params.projectId) {
        this.projectId = +params.projectId;
        this.loadProject(this.projectId);
      }
    });
  }

  subscribeStores() {
  this.authenticationStore.pipe(select(getLoggedInUser))
    .pipe(takeUntil(this.unsubscriber))
    .subscribe(user => {
        if (user) {
          this.currentUser = user;
          if (this.projectId && !this.registrationPlatformsBootstrap) {
            this.registrationPlatformsBootstrap = true;
            this.loadAllPlatforms();
          }
        }
      }
    );

    this.projectStore.pipe(select(getProjectError))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(error => {
        if (error) {
          this.toastrService.error(error, 'Error');
        }
      });
    this.projectStore.pipe(select(getProjectSuccess))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(success => {
        if (success) {
          if (this.isWebHookAdd && this.updateProjectAction) {
            this.updateProjectAction = false;
            this.loadAllPlatforms();
          }
        }
      });
    this.influencersStore.pipe(select(getInfluencersTypes))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(influencerType => {
        this.influencerTypes = [];
        if (influencerType && influencerType.length > 0) {
          influencerType.forEach(item => {
            this.influencerTypes.push({id: item.slug, name: item.name});
          });
        }
      });
    this.projectStore.pipe(select(getProjectSuccessResponse))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(updateProject => {
        if (updateProject) {
          this.project = this.withSafeRegistrationConfiguration(updateProject);
          this.loadAllPlatforms();
          this.submitted = false;
          this.currentSyncId = 0;
        }
      });
    this.influencersStore.pipe(select(getInfluencersProjectSegment))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(segments => {
        if (segments && segments.length > 0) {
          this.segments = segments;
          this.attendeeSegments = this.segments.filter(x => x.influencer_type_id === 3);
          this.speakerSegments = this.segments.filter(x => x.influencer_type_id === 5);
          this.partnerSegments = this.segments.filter(x => x.influencer_type_id === 6);
        }
      });
    this.projectStore.pipe(select(getProject))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(project => {
        if (project) {
          project = this.withSafeRegistrationConfiguration(project);
          this.project = project;
          if (this.directCall) {
            // const reg_platform = (typeof project.registration_platforms === 'string' ? JSON.parse(project.registration_platforms) : project.registration_platforms);
            // this.getUpdateRegistrationPlatform(reg_platform, this.savePlatformName);
            this.importProgress = {
              status: 'started',
              progress: 0
            };
            this.directCall = false;
          }
          if (project.registration_platforms) {
            this.authProjectRegistrationPlatform =  {...(typeof project.registration_platforms === 'string' ? JSON.parse(project.registration_platforms) : project.registration_platforms)};
            if (this.authProjectRegistrationPlatform.hasOwnProperty(this.savePlatformName)) {
              this.authSwapcardForm.patchValue({
                auth_key: this.authProjectRegistrationPlatform[this.savePlatformName].auth_key,
                event_id: this.authProjectRegistrationPlatform[this.savePlatformName].event_id,
                handle_deletion: this.authProjectRegistrationPlatform[this.savePlatformName].handle_deletion,
                skip_records_without_email: this.authProjectRegistrationPlatform[this.savePlatformName].skip_records_without_email,
                handle_already_skipped: this.authProjectRegistrationPlatform[this.savePlatformName].handle_already_skipped,
                enable_push_links: this.authProjectRegistrationPlatform[this.savePlatformName].enable_push_links,
              });
              if (this.savePlatformName && this.authProjectRegistrationPlatform[this.savePlatformName].handle_deletion){

              }

              if (this.savePlatformName === 'swapcard') {
                this.influencerKeysFormGroup.clear();
                const swap = this.authProjectRegistrationPlatform[this.savePlatformName];
                const legacyAttendee = swap.attendee_segment_id;
                const legacySpeaker = swap.speaker_segment_id;
                const legacyPartner = swap.partner_segment_id;
                const keys = swap?.influencer_keys;
                if (!keys?.length) {
                  this.influencerKeysFormGroup.push(this.addInfluencerKeysGroup());
                } else {
                  keys.forEach((index: { name?: string; category?: string; segmentId?: number | string }) => {
                    let segmentId = index.segmentId;
                    if (segmentId == null || segmentId === '') {
                      if (index.category === 'attendee') {
                        segmentId = legacyAttendee;
                      } else if (index.category === 'speaker') {
                        segmentId = legacySpeaker;
                      } else if (index.category === 'partner') {
                        segmentId = legacyPartner;
                      }
                    }
                    this.influencerKeysFormGroup.push(
                      this.formBuilder.group({
                        name: [index.name],
                        category: [index.category],
                        segmentId: [segmentId != null && segmentId !== '' ? Number(segmentId) : null]
                      })
                    );
                  });
                }
              }
              /* if(this.savePlatformName === 'swapcard' && this.authProjectRegistrationPlatform[this.savePlatformName].handle_deletion){
                 this.handle_deletion_value =  this.authProjectRegistrationPlatform[this.savePlatformName].handle_deletion;
               }
               if(this.savePlatformName === 'terrapin-salesforce' && this.authProjectRegistrationPlatform[this.savePlatformName].handle_deletion){
                 this.handle_deletion_value =  this.authProjectRegistrationPlatform[this.savePlatformName].handle_deletion;
               }*/
              this.authLineUpNinjaForm.patchValue({
                webhook: this.authProjectRegistrationPlatform[this.savePlatformName].webhook,
                username: this.authProjectRegistrationPlatform[this.savePlatformName].username,
                password: this.authProjectRegistrationPlatform[this.savePlatformName].password,
                api_url: this.authProjectRegistrationPlatform[this.savePlatformName].api_url,
                speaker_segment_id: Number(this.authProjectRegistrationPlatform[this.savePlatformName].speaker_segment_id),
                handle_deletion: this.authProjectRegistrationPlatform[this.savePlatformName].handle_deletion,
                skip_records_without_email: this.authProjectRegistrationPlatform[this.savePlatformName].skip_records_without_email,
                handle_already_skipped: this.authProjectRegistrationPlatform[this.savePlatformName].handle_already_skipped,
                enable_push_links: this.authProjectRegistrationPlatform[this.savePlatformName].enable_push_links,
              });
              this.authTerrapinSalesforceForm.patchValue({
                project_edition_id: this.authProjectRegistrationPlatform[this.savePlatformName]?.project_edition_id,
                speaker_segment_id: Number(this.authProjectRegistrationPlatform[this.savePlatformName].speaker_segment_id),
                other_attendee_segment_id: Number(this.authProjectRegistrationPlatform[this.savePlatformName].other_attendee_segment_id),
                sponsor_segment_id: Number(this.authProjectRegistrationPlatform[this.savePlatformName].sponsor_segment_id),
                exhibitor_segment_id: Number(this.authProjectRegistrationPlatform[this.savePlatformName].exhibitor_segment_id),
                guest_segment_id: Number(this.authProjectRegistrationPlatform[this.savePlatformName].guest_segment_id),
                handle_deletion: this.authProjectRegistrationPlatform[this.savePlatformName].handle_deletion,
                skip_records_without_email: this.authProjectRegistrationPlatform[this.savePlatformName].skip_records_without_email,
                handle_already_skipped: this.authProjectRegistrationPlatform[this.savePlatformName].handle_already_skipped,
                enable_push_links: this.authProjectRegistrationPlatform[this.savePlatformName].enable_push_links,
              });

              this.authSessionBoardForm.patchValue({
                event_id: this.authProjectRegistrationPlatform[this.savePlatformName]?.event_id,
                access_token: this.authProjectRegistrationPlatform[this.savePlatformName]?.access_token,
                speaker_segment_id: Number(this.authProjectRegistrationPlatform[this.savePlatformName].speaker_segment_id),
                // attendee_segment_id: Number(this.authProjectRegistrationPlatform[this.savePlatformName].attendee_segment_id),
                partner_segment_id: Number(this.authProjectRegistrationPlatform[this.savePlatformName].partner_segment_id),
                handle_deletion: this.authProjectRegistrationPlatform[this.savePlatformName].handle_deletion,
                skip_records_without_email: this.authProjectRegistrationPlatform[this.savePlatformName].skip_records_without_email,
                handle_already_skipped: this.authProjectRegistrationPlatform[this.savePlatformName].handle_already_skipped,
                enable_push_links: this.authProjectRegistrationPlatform[this.savePlatformName].enable_push_links,
              });

              this.authCadmiumForm.patchValue({
                api_key: this.authProjectRegistrationPlatform[this.savePlatformName]?.api_key,
                filter_by: this.authProjectRegistrationPlatform[this.savePlatformName]?.filter_by,
                // event_id: this.authProjectRegistrationPlatform[this.savePlatformName]?.event_id,
                // attendee_segment_id: Number(this.authProjectRegistrationPlatform[this.savePlatformName].attendee_segment_id),
                // partner_segment_id: Number(this.authProjectRegistrationPlatform[this.savePlatformName].partner_segment_id),
                speaker_segment_id: Number(this.authProjectRegistrationPlatform[this.savePlatformName].speaker_segment_id),
                handle_deletion: this.authProjectRegistrationPlatform[this.savePlatformName].handle_deletion,
                skip_records_without_email: this.authProjectRegistrationPlatform[this.savePlatformName].skip_records_without_email,
                handle_already_skipped: this.authProjectRegistrationPlatform[this.savePlatformName].handle_already_skipped,
                enable_push_links: this.authProjectRegistrationPlatform[this.savePlatformName].enable_push_links,
              })

              this.authSwoogoForm.patchValue({
                api_key: this.authProjectRegistrationPlatform[this.savePlatformName]?.api_key,
                api_secret: this.authProjectRegistrationPlatform[this.savePlatformName]?.api_secret,
                event_id: this.authProjectRegistrationPlatform[this.savePlatformName]?.event_id,
                speaker_segment_id: Number(this.authProjectRegistrationPlatform[this.savePlatformName].speaker_segment_id),
                partner_segment_id: Number(this.authProjectRegistrationPlatform[this.savePlatformName].partner_segment_id),
                handle_deletion: this.authProjectRegistrationPlatform[this.savePlatformName].handle_deletion,
                skip_records_without_email: this.authProjectRegistrationPlatform[this.savePlatformName].skip_records_without_email,
                handle_already_skipped: this.authProjectRegistrationPlatform[this.savePlatformName].handle_already_skipped,
                enable_push_links: this.authProjectRegistrationPlatform[this.savePlatformName].enable_push_links,
              })
              this.authSwoogoSponsorsForm.patchValue({
                api_key: this.authProjectRegistrationPlatform[this.savePlatformName]?.api_key,
                api_secret: this.authProjectRegistrationPlatform[this.savePlatformName]?.api_secret,
                event_id: this.authProjectRegistrationPlatform[this.savePlatformName]?.event_id,
                speaker_segment_id: Number(this.authProjectRegistrationPlatform[this.savePlatformName].speaker_segment_id),
                partner_segment_id: Number(this.authProjectRegistrationPlatform[this.savePlatformName].partner_segment_id),
                handle_deletion: this.authProjectRegistrationPlatform[this.savePlatformName].handle_deletion,
                skip_records_without_email: this.authProjectRegistrationPlatform[this.savePlatformName].skip_records_without_email,
                handle_already_skipped: this.authProjectRegistrationPlatform[this.savePlatformName].handle_already_skipped,
                enable_push_links: this.authProjectRegistrationPlatform[this.savePlatformName].enable_push_links,
              })
              this.authTechEventForm.patchValue({
                api_key: this.authProjectRegistrationPlatform[this.savePlatformName]?.api_key,
                partner_segment_id: Number(this.authProjectRegistrationPlatform[this.savePlatformName].partner_segment_id),
                handle_deletion: this.authProjectRegistrationPlatform[this.savePlatformName].handle_deletion,
                skip_records_without_email: this.authProjectRegistrationPlatform[this.savePlatformName].skip_records_without_email,
                handle_already_skipped: this.authProjectRegistrationPlatform[this.savePlatformName].handle_already_skipped,
                enable_push_links: this.authProjectRegistrationPlatform[this.savePlatformName].enable_push_links,
              })

              const savedMappings = this.authProjectRegistrationPlatform[this.savePlatformName]?.field_mappings || {};
              this.visibleFields = Object.keys(savedMappings).map(key => {
                const fullMeta = this.allFields.find(f => f.key === key);
                return {
                  key,
                  label: fullMeta?.label || key,
                  value: savedMappings[key]
                };
              })

              this.authCventForm.patchValue({
                client_secret: this.authProjectRegistrationPlatform[this.savePlatformName]?.client_secret,
                client_id: this.authProjectRegistrationPlatform[this.savePlatformName]?.client_id,
                event_id: this.authProjectRegistrationPlatform[this.savePlatformName]?.event_id,
                custom_snoball_field: this.authProjectRegistrationPlatform[this.savePlatformName]?.custom_snoball_field,
                partner_segment_id: Number(this.authProjectRegistrationPlatform[this.savePlatformName].partner_segment_id),
                speaker_segment_id: Number(this.authProjectRegistrationPlatform[this.savePlatformName].speaker_segment_id),
                handle_deletion: this.authProjectRegistrationPlatform[this.savePlatformName].handle_deletion,
                skip_records_without_email: this.authProjectRegistrationPlatform[this.savePlatformName].skip_records_without_email,
                handle_already_skipped: this.authProjectRegistrationPlatform[this.savePlatformName].handle_already_skipped,
                enable_push_links: this.authProjectRegistrationPlatform[this.savePlatformName].enable_push_links,
                enable_admin_sync: this.authProjectRegistrationPlatform[this.savePlatformName].enable_admin_sync || false,
              })

              this.authMockForm.patchValue({
                number_of_records: this.authProjectRegistrationPlatform[this.savePlatformName]?.number_of_records || '10',
                attendee_segment_id: Number(this.authProjectRegistrationPlatform[this.savePlatformName].attendee_segment_id),
                speaker_segment_id: Number(this.authProjectRegistrationPlatform[this.savePlatformName].speaker_segment_id),
                partner_segment_id: Number(this.authProjectRegistrationPlatform[this.savePlatformName].partner_segment_id),
                handle_deletion: this.authProjectRegistrationPlatform[this.savePlatformName]?.handle_deletion || 'keep_on_snoball',
                skip_records_without_email: this.authProjectRegistrationPlatform[this.savePlatformName].skip_records_without_email,
                handle_already_skipped: this.authProjectRegistrationPlatform[this.savePlatformName].handle_already_skipped,
                simulate_failure: this.authProjectRegistrationPlatform[this.savePlatformName]?.simulate_failure || false,
                enable_push_links: this.authProjectRegistrationPlatform[this.savePlatformName].enable_push_links,
              })

              this.authMapYourShowForm.patchValue({
                show_code: this.authProjectRegistrationPlatform[this.savePlatformName]?.show_code,
                exhibitor_segment_id: Number(this.authProjectRegistrationPlatform[this.savePlatformName].exhibitor_segment_id),
                speaker_segment_id: Number(this.authProjectRegistrationPlatform[this.savePlatformName].speaker_segment_id) || null,
                handle_deletion: this.authProjectRegistrationPlatform[this.savePlatformName].handle_deletion,
                skip_records_without_email: this.authProjectRegistrationPlatform[this.savePlatformName].skip_records_without_email,
                handle_already_skipped: this.authProjectRegistrationPlatform[this.savePlatformName].handle_already_skipped,
                skip_records_with_faulty_image: this.authProjectRegistrationPlatform[this.savePlatformName].skip_records_with_faulty_image,
                filter_by_status_approved: this.authProjectRegistrationPlatform[this.savePlatformName].filter_by_status_approved,
                skip_duplicate_contacts: this.authProjectRegistrationPlatform[this.savePlatformName].skip_duplicate_contacts,
                enable_push_links: this.authProjectRegistrationPlatform[this.savePlatformName].enable_push_links,
              });

              // tenant_id is a credential: write-only, never sent back, so it is not pre-filled.
              this.authPersonifyA2ZForm.patchValue({
                event_id: this.authProjectRegistrationPlatform[this.savePlatformName].event_id,
                promo_code_field_name: this.authProjectRegistrationPlatform[this.savePlatformName].promo_code_field_name?.trim() ?? '',
                reg_link_field_name: this.authProjectRegistrationPlatform[this.savePlatformName].reg_link_field_name?.trim() ?? '',
                custom_contact_field_name: this.authProjectRegistrationPlatform[this.savePlatformName].custom_contact_field_name?.trim() ?? '',
                partner_segment_id: Number(this.authProjectRegistrationPlatform[this.savePlatformName].partner_segment_id),
                handle_deletion: this.authProjectRegistrationPlatform[this.savePlatformName].handle_deletion,
                skip_records_without_email: this.authProjectRegistrationPlatform[this.savePlatformName].skip_records_without_email,
                handle_already_skipped: this.authProjectRegistrationPlatform[this.savePlatformName].handle_already_skipped,
                skip_duplicate_contacts:this.authProjectRegistrationPlatform[this.savePlatformName].skip_duplicate_contacts,
                enable_push_links: this.authProjectRegistrationPlatform[this.savePlatformName].enable_push_links,
                include_booth_contact: this.authProjectRegistrationPlatform[this.savePlatformName].include_booth_contact || false,
              });

              if (this.savePlatformName === 'terrapin-salesforce') {
                this.selectedSalesForceSpeakerSegment = this.authProjectRegistrationPlatform[this.savePlatformName].speaker_segment_id || null;
                this.selectedSalesForceOtherAttendeeSegment = this.authProjectRegistrationPlatform[this.savePlatformName].other_attendee_segment_id || null;
                this.selectedSalesForceSponsorSegment = this.authProjectRegistrationPlatform[this.savePlatformName].sponsor_segment_id || null;
                this.selectedSalesForceExhibitorSegment = this.authProjectRegistrationPlatform[this.savePlatformName].exhibitor_segment_id || null;
                this.selectedSalesForceGuestSegment = this.authProjectRegistrationPlatform[this.savePlatformName].guest_segment_id || null;
              } else if (this.savePlatformName === 'map-your-show') {
                this.selectedMYSExhibitorSegment = this.authProjectRegistrationPlatform[this.savePlatformName].exhibitor_segment_id || null;
                this.selectedMYSSpeakerSegment = this.authProjectRegistrationPlatform[this.savePlatformName].speaker_segment_id || null;
              } else {
                this.selectedAttendeeSegment = this.authProjectRegistrationPlatform[this.savePlatformName].attendee_segment_id || null;
                this.selectedSpeakerSegment = this.authProjectRegistrationPlatform[this.savePlatformName].speaker_segment_id || null;
                this.selectedPartnerSegment = this.authProjectRegistrationPlatform[this.savePlatformName].partner_segment_id || null;
              }

            }
          } else {
            this.authProjectRegistrationPlatform = {};
          }
        }
      });
    this.registrationPlatformStore.pipe(select(getSyncInfluencers))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(influencersSync => {
        if (influencersSync) {
          if (influencersSync !== true) {
            let errorMessage = '';
            // Sync status response for a job that failed in the task runner: the backend
            // returns the job's failure reason so the user can see why the sync failed.
            if (influencersSync.status === 'failed' && influencersSync.failedReason) {
              this.loaderImport.next(false);
              this.toastr.error(influencersSync.failedReason, 'Sync failed');
            } else if (!influencersSync.success) {
              this.importJobId = influencersSync.data?.jobId;
              if (influencersSync.error) {
                if (influencersSync.error.name === 'AppTimeoutError') {
                  errorMessage = 'Upload timeout';
                }
                if (influencersSync.error.name === 'AppError') {
                  errorMessage = influencersSync.message;
                }
                if (influencersSync.error.name === 'AppValidationError') {
                  errorMessage = influencersSync.error.orgMessage || 'Invalid Records';
                  this.importData = influencersSync.data;
                  this.showSyncLogs();
                }
              }
              if (errorMessage) {
                this.toastr.error(errorMessage, 'Error');
              }
            }
          } else {
            // this.modal.close();
          }
        }
      });
    this.registrationPlatformStore.pipe(select(getRegistrationPlatformError))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(error => {
        if (error) {
          this.toastrService.error(error, 'Error');
        }
      });

    this.registrationPlatformStore.pipe(select(getInfluencersSyncError))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(error => {
        if (error) {
          this.loaderImport.next(false);
          this.toastrService.error(error, 'Error');
        }
      });

    this.registrationPlatformStore.pipe(select(getRegistrationPlatformSuccess))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(success => {
        if (success) {
          if (this.deleteAction || this.updateAction) {
            this.deleteAction = false;
            this.updateAction = false;
            this.loadAllPlatforms();
          }
        }
      });

    this.registrationPlatformStore.pipe(select(getRegistrationPlatformPaginated))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe((paginatedRegistrationPlatform: any) => {
          if (paginatedRegistrationPlatform) {
            this.registrationPlatformList = paginatedRegistrationPlatform.list || [];
            this.registrationPlatformsLoaded = true;
            if (this.isWebHookAdd) {
              this.showPlatformJsonPopup(this.currentModel, this.currentPlatform);
              this.isWebHookAdd = false;
            }
          }
        }
      );
  }

  subscribeToSocket() {
    this.socketSubscription = this.socketService.sourceData.subscribe(
      (message: any) => {
        if (message?.data?.requesterType === 'influencer_sync' && (!this.importJobId || message?.data?.id === this.importJobId)) {
          this.loaderImport.next(true);
          this.currentSyncId = message.data.platform_id;
          this.savePlatformName = message.data.platform_name;
          //
          // Set job id
          this.importJobId = message.data.id;

          //
          // Update import progress
          this.importProgress.status = message.data?.status;
          this.importProgress.progress = message?.data?.progress;
          let reg_platform;
          // adjust loading state for finished/failed
          if (['finished', 'failed'].includes(this.importProgress.status)) {
            setTimeout(() => {
              this.loaderImport.next(false);
              // Keep status
              const status: string = this.importProgress?.status;
              reg_platform = {...(typeof this.project.registration_platforms === 'string' ? JSON.parse(this.project.registration_platforms) : this.project.registration_platforms)};
              if (status === 'failed') {
                this.syncStatus();
                this.importProgress = {
                  status: 'started',
                  progress: 0
                };
              } else if (status === 'finished' && this.savePlatformName) { // On finished(success) should close modal, clear job id and data
                this.importJobId = null;
                this.importData = null;
                this.toastr.success('Sync successful', 'Success');
                if (!this.isSubmit) {
                  this.directCall = true;
                } else {
                  // this.getUpdateRegistrationPlatform(reg_platform, this.savePlatformName);
                  this.isSubmit = false;
                }
                this.loadProject(this.projectId);
                this.importProgress = {
                  status: 'started',
                  progress: 0
                };
                this.savePlatformName = '';
              }
            }, 1500);
          }
        }
      },
      (err) => console.error(err),
      () => console.warn('Completed!')
    );
  }

  ngOnInit() {
    this.subscribeStores();
    this.loader$ = this.loaderService.loader$;
    this.authSwapcardForm = this.formBuilder.group({
      auth_key: [''],
      influencer_keys: this.formBuilder.array([]),
      event_id: ['', Validators.required],
      skip_records_without_email: false,
      handle_already_skipped: false,
      handle_deletion: [''],
      enable_push_links: false,
    });
    this.authLineUpNinjaForm = this.formBuilder.group({
      webhook: [''],
      api_url: ['', Validators.pattern(this.constants.urlRegex)],
      username: [''],
      password: [''],
      speaker_segment_id: [null],
      handle_deletion: 'skip_on_snoball',
      skip_records_without_email: false,
      handle_already_skipped: false,
      enable_push_links: false,
      // handle_deletion: [''],
    });

    this.authTerrapinSalesforceForm = this.formBuilder.group({
      project_edition_id: ['', Validators.required],
      speaker_segment_id: [null],
      other_attendee_segment_id: [null],
      sponsor_segment_id: [null],
      exhibitor_segment_id: [null],
      guest_segment_id: [null],
      handle_deletion: 'skip_on_snoball',
      skip_records_without_email: false,
      handle_already_skipped: false,
      enable_push_links: false,
    });

    this.authSessionBoardForm = this.formBuilder.group({
      event_id: ['', Validators.required],
      access_token: [''],
      // attendee_segment_id: [null],
      partner_segment_id: [null],
      speaker_segment_id: [null],
      handle_deletion: 'skip_on_snoball',
      skip_records_without_email: false,
      handle_already_skipped: false,
      enable_push_links: false,
    });

    this.authCadmiumForm = this.formBuilder.group({
      api_key: [''],
      filter_by: [''],
      // event_id: [null],
      // attendee_segment_id: [null],
      // partner_segment_id: [null],
      speaker_segment_id: [null],
      handle_deletion: 'skip_on_snoball',
      skip_records_without_email: false,
      handle_already_skipped: false,
      enable_push_links: false,
    })
    this.authSwoogoForm = this.formBuilder.group({
      api_key: [''],
      api_secret: [''],
      event_id: ['', Validators.required],
      speaker_segment_id: [null],
      partner_segment_id: [null],
      handle_deletion: 'skip_on_snoball',
      skip_records_without_email: false,
      handle_already_skipped: false,
      enable_push_links: false,
      field_mappings: this.formBuilder.control({})
    })
    this.authSwoogoSponsorsForm = this.formBuilder.group({
      api_key: [''],
      api_secret: [''],
      event_id: ['', Validators.required],
      speaker_segment_id: [null],
      partner_segment_id: [null],
      handle_deletion: 'skip_on_snoball',
      skip_records_without_email: false,
      handle_already_skipped: false,
      enable_push_links: false,
      field_mappings: this.formBuilder.control({})
    })

    this.authTechEventForm = this.formBuilder.group({
      api_key: [''],
      partner_segment_id: [null],
      handle_deletion: 'skip_on_snoball',
      skip_records_without_email: false,
      handle_already_skipped: false,
      enable_push_links: false
    })


    this.authCventForm = this.formBuilder.group({
      client_secret: [''],
      client_id: [''],
      event_id: ['', Validators.required],
      custom_snoball_field: [null],
      partner_segment_id: [null],
      speaker_segment_id: [null],
      handle_deletion: 'skip_on_snoball',
      skip_records_without_email: false,
      handle_already_skipped: false,
      enable_push_links: false,
      enable_admin_sync: false,
    })

    this.authMockForm = this.formBuilder.group({
      number_of_records: ['10', Validators.required],
      attendee_segment_id: [null],
      speaker_segment_id: [null],
      partner_segment_id: [null],
      handle_deletion: 'keep_on_snoball',
      skip_records_without_email: false,
      handle_already_skipped: false,
      simulate_failure: false,
      enable_push_links: false,
    })

    this.authMapYourShowForm = this.formBuilder.group({
      show_code: ['', Validators.required],
      exhibitor_segment_id: [null],
      speaker_segment_id: [null],
      handle_deletion: 'skip_on_snoball',
      skip_records_without_email: false,
      handle_already_skipped: false,
      skip_records_with_faulty_image: false,
      filter_by_status_approved: false,
      skip_duplicate_contacts: false,
      enable_push_links: false,
    });

    this.authPersonifyA2ZForm = this.formBuilder.group({
      event_id: ['', [Validators.required, Validators.pattern('^[0-9]+$')]],
      // Required unless already configured server-side; checked on save like the other secrets.
      tenant_id: [''],
      reg_link_field_name: ['customField.Reg Link'],
      promo_code_field_name: ['customField.Promo Codes'],
      partner_segment_id: [null],
      custom_contact_field_name: ['$.eventContacts[?(@.type=="HD Contract Contact" || @.type=="HD Marketing Contact")]'],
      handle_deletion: 'skip_on_snoball',
      skip_records_without_email: false,
      handle_already_skipped: false,
      skip_duplicate_contacts: false,  
      enable_push_links: false,
      include_booth_contact: false,
    });


    this.subscribeToSocket();
    this.getInfluencerTypes();
  }

  /** Empty-state copy for the card grid (not a table). */
  get registrationPlatformsEmptyMessage(): string {
    return (this.platformSearchQuery || '').trim()
      ? 'No platforms match your search.'
      : 'No registration platforms found.';
  }

  onRegistrationPlatformSearchChange(): void {
    clearTimeout(this.searchDelay);
    this.searchDelay = setTimeout(() => {
      this.loadAllPlatforms(0, 100);
    }, 1000);
  }

  public loadAllPlatforms(page = 0, perPage = 100, search?: string) {
    const term = search !== undefined ? (search || '').trim() : (this.platformSearchQuery || '').trim();
    const options = {includePagination: true, includeProjects: false, sync_support: true};
    if (this.projectId && this.currentUser?.can( 'filter-platforms-by-project', 'project-ui')) {
      options['project_id'] = this.projectId;
    }
    this.registrationPlatformStore.dispatch(RegistrationPlatformListPaginated({
      params: {
        options: JSON.stringify(options),
        page: page + 1,
        perPage,
        search: term
      }
    }));
  }

  private loadProject(id) {
    this.projectStore.dispatch(ProjectGet({projectId: id}));
  }

  getUpdateRegistrationPlatform(platform, name) {
    platform[name] = {...platform[name], last_sync_time: new Date()};
    const params: any = {
      registration_platforms: platform,
    };
    this.projectStore.dispatch(ProjectUpdate({project: params, projectId: this.projectId}));
  }

  /**
   * Initials on cards: first letter of each word (e.g. "Map Your Show" → MYS); single word → one letter.
   */
  getPlatformCardInitials(name: string | null | undefined): string {
    if (name == null || typeof name !== 'string') {
      return '?';
    }
    const trimmed = name.trim();
    if (!trimmed) {
      return '?';
    }
    const parts = trimmed.split(/\s+/).filter((p) => p.length > 0);
    if (parts.length === 1) {
      return parts[0].charAt(0).toUpperCase();
    }
    return parts.map((p) => p.charAt(0).toUpperCase()).join('');
  }

  submitInfluencerSync(platform, index) {
    this.currentSyncId = platform.id;
    this.currentIndex = index;
    this.isSubmit = true;
    this.currentSyncPlatform = platform;
    this.savePlatformName = platform.slug;
    const data = {
      project_id: this.projectId,
      registration_platform_id:  this.currentSyncId
    };
    this.loaderImport.next(true);
    this.registrationPlatformStore.dispatch(InfluencersSync({data: data}));
  }

  onActiveChange (isChecked, cadmiumModel, cventModel, swoogoModel,swoogoSponsorModel, mockModel, swapcardModel, lineUpNinjaModel, terrapinSalesforceModel, sessionBoardModel, mapYourShowModel, personifyA2zModel, techEventModel, platform, index) {
    this.currentIndex = index;
    this.currentPlatform = platform;
    this.shareSyncLinkUrl = environment.frontUrl.replace('/#', '') + `/b/sync_instruction/${platform.id}`;
    const name = platform.slug;
    const project = JSON.parse(JSON.stringify(this.project));
    let reg_platform = (typeof project.registration_platforms === 'string' ? JSON.parse(project.registration_platforms) : project.registration_platforms);
    if (platform.slug === 'swapcard') {
      this.currentModel = swapcardModel;
    } else if (platform.slug === 'lineup-ninja') {
      this.currentModel = lineUpNinjaModel;
    } else if (platform.slug === 'session-board') {
      this.currentModel = sessionBoardModel;
    } else if (platform.slug === 'terrapin-salesforce' || platform.name === 'Salesforce') {
      this.currentModel = terrapinSalesforceModel;
    } else if (platform.slug === 'map-your-show') {
      this.currentModel = mapYourShowModel;
    } else if (platform.slug === 'personify-a2z') {
      this.currentModel = personifyA2zModel;
    } else if (platform.slug === 'cadmium') {
      this.currentModel = cadmiumModel;
    } else if (platform.slug === 'swoogo-registration-platform') {
      this.currentModel = swoogoModel;
    } else if (platform.slug === 'swoogo-sponsors-registration-platform') {
      this.currentModel = swoogoSponsorModel;
    } else if (platform.slug === 'cvent-registration-platform') {
      this.currentModel = cventModel;
    } else if (platform.slug === 'mock-registration-platform') {
      this.currentModel = mockModel;
    } else if (platform.slug === 'tech-event') {
      this.currentModel = techEventModel;
    }
    if (isChecked) {
      if ((!reg_platform || !reg_platform[name]?.hasOwnProperty('webhook') || (reg_platform[name]?.hasOwnProperty('webhook') && !reg_platform[name].webhook)) && name !== 'swapcard' && name !== 'terrapin-salesforce' && name !== 'session-board' && name !== 'map-your-show' && name !== 'personify-a2z' && name !== 'cadmium' && name !== 'swoogo-sponsors-registration-platform' && name !== 'swoogo-registration-platform' && name !== 'cvent-registration-platform' && name !== 'mock-registration-platform' && name !== 'tech-event') {
        if (!reg_platform) { reg_platform = {}; }
        try {
          this.updateProjectAction = true;
          this.isWebHookAdd = true;
          this.registrationPlatformService.getWebHook(this.projectId, name).subscribe(response => {
            if (response['data']) {
              this.updateAction = true;
              reg_platform[name] = {
                webhook : response['data'].webhook,
              };
              const params: any = {
                registration_platforms: reg_platform,
              };
              this.projectStore.dispatch(ProjectUpdate({project: params, projectId: this.projectId}));
            }
          });
        } catch (e) {
          console.log(e);
        }
      } else {
        this.showPlatformJsonPopup(this.currentModel, platform);
      }

    } else {
      this.updateAction = true;
      reg_platform[name].active = false;
      const params: any = {
        registration_platforms:  reg_platform,
      };
      this.projectStore.dispatch(ProjectUpdate({project: params, projectId: this.projectId}));
      const platformObj = JSON.parse(JSON.stringify(platform));
      let project_ids = platformObj.project_id ? platformObj.project_id.split(',') : [];
      if (project_ids.includes(this.projectId.toString())) {
        project_ids = project_ids.filter( (item) => item !== this.projectId.toString());
        platformObj['project_id'] = project_ids.length > 0 ? project_ids.toString() : '';
      }
      // this.loadAllPlatforms();
    }
  }
  resetSwapcardForm() {
    this.influencerKeysFormGroup.clear();
    this.authSwapcardForm.reset();
  }

  showPlatformJsonPopup(platformAuthModel, platform) {
    this.submitted = false;
    this.isSwapcardFormValid = true;
    this.isTerrapinSalesforceFormValid = true;
    this.isSegmentSelect = '';
    // this.authSwapcardForm.reset();
    this.resetSwapcardForm();
    this.platformName = platform.name;
    this.apiIntegrationGuide = platform.api_integration_guide;
    this.platformId = platform.id;
    this.savePlatformName = platform.slug;
    this.projectStore.dispatch(ProjectGet({projectId: this.projectId}));
    this.influencersStore.dispatch(InfluencersProjectSegment({projectId: this.projectId}));
    const modelRef = this._modalService.open(platformAuthModel, {
      centered: true,
      size: 'xl',
      keyboard: false,
      backdrop: 'static',
      windowClass: 'api-platform-auth-modal',
    });
    modelRef.result.then((result) => {
    }, (reason) => {
    });
  }

  openApiIntegrationGuideModel(model) {
    this.apiIntegrationModelRef = this._modalService.open(model, {
      centered: true,
      keyboard: false,
      scrollable: true,
      windowClass: 'modal-header-api-integration api-platform-auth-modal',
    });
    this.apiIntegrationModelRef.result.then((result) => {
    }, (reason) => {
    });
  }

  onCancelApiIntegrationModel() {
    if (this.apiIntegrationModelRef) {
      this.apiIntegrationModelRef.close();
      this.apiIntegrationModelRef = null;
    }
  }

  swapcardInfluencerKeyRowComplete(row: { name?: unknown; category?: unknown; segmentId?: unknown }) {
    const name = row?.name != null && String(row.name).trim() !== '';
    const cat = row?.category != null && row.category !== 'null' && String(row.category).trim() !== '';
    const seg = row?.segmentId != null && row.segmentId !== '';
    return name && cat && seg;
  }

  swapcardInfluencerKeyRowPartial(row: { name?: unknown; category?: unknown; segmentId?: unknown }) {
    const name = row?.name != null && String(row.name).trim() !== '';
    const cat = row?.category != null && row.category !== 'null' && String(row.category).trim() !== '';
    const seg = row?.segmentId != null && row.segmentId !== '';
    const any = name || cat || seg;
    const all = name && cat && seg;
    return any && !all;
  }

  allObjectsHaveValues(data, allowOneNull = false) {
    if (!data?.length) {
      return false;
    }
    if (allowOneNull) {
      return (
        data.some(row => this.swapcardInfluencerKeyRowComplete(row)) &&
        !data.some(row => this.swapcardInfluencerKeyRowPartial(row))
      );
    }
    return data.some(row => this.swapcardInfluencerKeyRowComplete(row));
  }


  savePlatformAuth() {
    this.submitted = true;
    this.isSwapcardFormValid = true;
    if (this.savePlatformName === 'swapcard') {
      if (this.authSwapcardForm.invalid || !this.requireCredential(
        'auth_key', this.authSwapcardForm.value.auth_key, 'Auth Key'
      )) {
        return;
      }

      if (!this.authSwapcardForm.value.influencer_keys?.length || (this.authSwapcardForm.value.influencer_keys?.length && !this.allObjectsHaveValues(this.authSwapcardForm.value.influencer_keys, true))) {
        this.isSegmentSelect = '';
        this.isSwapcardFormValid = false;
        return;
      }
      this.isSegmentSelect = '';
      const rawKeys = this.authSwapcardForm.value.influencer_keys || [];
      this.authSwapcardForm.value.influencer_keys = rawKeys
        .filter(row => this.swapcardInfluencerKeyRowComplete(row))
        .map(row => ({
          name: row.name,
          category: row.category,
          segmentId: row.segmentId
        }));
      this.authSwapcardForm.value.active = true;
      this.authSwapcardForm.value.integration = true;
      const swapcardPayload = { ...this.authSwapcardForm.value };
      delete swapcardPayload.webhook;
      this.authProjectRegistrationPlatform[this.savePlatformName] = swapcardPayload;
    }

    if (this.savePlatformName === 'lineup-ninja') {
      if (this.authLineUpNinjaForm.invalid && this.authLineUpNinjaForm.value.api_url) {
        return;
      }
      const hasUsername = this.hasCredential(
        'username', this.authLineUpNinjaForm.value.username
      );
      const hasPassword = this.hasCredential(
        'password', this.authLineUpNinjaForm.value.password
      );
      if (this.authLineUpNinjaForm.value.api_url && (!hasUsername || !hasPassword)) {
        this.isLienUpNinjaFormValid = false;
        return;
      }
      if (!this.selectedSpeakerSegment) {
        this.isSegmentSelect = 'Please Select Speaker Segment';
        return;
      } else {
        this.authLineUpNinjaForm.value.speaker_segment_id = this.selectedSpeakerSegment;
      }
      this.authLineUpNinjaForm.value.integration = !!(
        this.authLineUpNinjaForm.value.api_url && hasUsername && hasPassword
      );
      this.authLineUpNinjaForm.value.active = true;
      this.authProjectRegistrationPlatform[this.savePlatformName] = this.authLineUpNinjaForm.value;
    }

    if (this.savePlatformName === 'terrapin-salesforce') {
      if (!this.authTerrapinSalesforceForm.value.project_edition_id) {
        this.isTerrapinSalesforceFormValid = false;
        return;
      }
      if (!this.selectedSalesForceOtherAttendeeSegment) {
        this.isSegmentSelect = 'Please Select Other Attendee Segment';
        return;
      } else {
        this.authTerrapinSalesforceForm.value.other_attendee_segment_id = this.selectedSalesForceOtherAttendeeSegment;
      }

      if (!this.selectedSalesForceSpeakerSegment) {
        this.isSegmentSelect = 'Please Select Speaker Segment';
        return;
      } else {
        this.authTerrapinSalesforceForm.value.speaker_segment_id = this.selectedSalesForceSpeakerSegment;
      }

      if (!this.selectedSalesForceGuestSegment) {
        this.isSegmentSelect = 'Please Select Guest Segment';
        return;
      } else {
        this.authTerrapinSalesforceForm.value.guest_segment_id = this.selectedSalesForceGuestSegment;
      }

      if (!this.selectedSalesForceSponsorSegment) {
        this.isSegmentSelect = 'Please Select Partner Segment';
        return;
      } else {
        this.authTerrapinSalesforceForm.value.sponsor_segment_id = this.selectedSalesForceSponsorSegment;
      }

      if (!this.selectedSalesForceExhibitorSegment) {
        this.isSegmentSelect = 'Please Select Exhibitor Segment';
        return;
      } else {
        this.authTerrapinSalesforceForm.value.exhibitor_segment_id = this.selectedSalesForceExhibitorSegment;
      }
      this.authTerrapinSalesforceForm.value.active = true;
      this.authTerrapinSalesforceForm.value.integration = true;
      this.authProjectRegistrationPlatform[this.savePlatformName] = this.authTerrapinSalesforceForm.value;
    }
    if (this.savePlatformName === 'session-board') {
      if (!this.authSessionBoardForm.value.event_id) {
        this.isSessionBoardFormValid = false;
        return;
      }

      if (!this.requireCredential(
        'access_token', this.authSessionBoardForm.value.access_token, 'Access Token'
      )) {
        this.isSessionBoardFormValid = false;
        return;
      }

      /*if (!this.selectedAttendeeSegment) {
        this.isSegmentSelect = 'Please Select Attendee Segment';
        return;
      } else {
        this.authSessionBoardForm.value.attendee_segment_id = this.selectedAttendeeSegment;
      }*/

      if (!this.selectedSpeakerSegment && !this.selectedPartnerSegment) {
        this.isSegmentSelect = 'Please Select A Segment';
        return;
      }

      this.authSessionBoardForm.value.speaker_segment_id = this.selectedSpeakerSegment || null;
      this.authSessionBoardForm.value.partner_segment_id = this.selectedPartnerSegment || null;
      this.authSessionBoardForm.value.active = true;
      this.authSessionBoardForm.value.integration = true;
      this.authProjectRegistrationPlatform[this.savePlatformName] = this.authSessionBoardForm.value;
    }

    if (this.savePlatformName === 'map-your-show') {
      if (this.authMapYourShowForm.invalid) {
        this.isMapYourShowFormValid = false;
        return;
      }
      if (!this.selectedMYSExhibitorSegment && !this.selectedMYSSpeakerSegment) {
        this.isSegmentSelect = 'Please Select A Segment';
        return;
      }
      this.authMapYourShowForm.value.exhibitor_segment_id = this.selectedMYSExhibitorSegment || null;
      this.authMapYourShowForm.value.speaker_segment_id = this.selectedMYSSpeakerSegment || null;
      this.authMapYourShowForm.value.integration = !!(this.authMapYourShowForm.value.show_code);
      this.authMapYourShowForm.value.active = true;
      this.authMapYourShowForm[this.savePlatformName] = this.authMapYourShowForm.value;
      this.authProjectRegistrationPlatform[this.savePlatformName] = this.authMapYourShowForm.value;
    }

    if (this.savePlatformName === 'personify-a2z') {
      if (this.authPersonifyA2ZForm.invalid || !this.requireCredential(
        'tenant_id', this.authPersonifyA2ZForm.value.tenant_id, 'Tenant ID'
      )) {
        this.isPersonifyA2ZFormValid = false;
        return;
      }

      if (!this.selectedPartnerSegment) {
        this.isSegmentSelect = 'Please Select Partner Segment';
        return;
      } else {
        this.authPersonifyA2ZForm.value.partner_segment_id = this.selectedPartnerSegment;
      }
      this.authPersonifyA2ZForm.value.active = true;
      this.authPersonifyA2ZForm.value.integration = true;
      this.authPersonifyA2ZForm[this.savePlatformName] = this.authPersonifyA2ZForm.value;
      this.authProjectRegistrationPlatform[this.savePlatformName] = this.authPersonifyA2ZForm.value;
    }

    if (this.savePlatformName === 'cadmium') {
      if (this.authCadmiumForm.invalid || !this.requireCredential(
        'api_key', this.authCadmiumForm.value.api_key, 'API Key'
      )) {
        this.isCadmiumFormValid = false;
        return;
      }

      if (!this.selectedSpeakerSegment) {
        this.isSegmentSelect = 'Please Select A Segment';
        return;
      }
      this.authCadmiumForm.value.speaker_segment_id = this.selectedSpeakerSegment || null;
      // this.authCadmiumForm.value.speaker_segment_id = this.selectedAttendeeSegment || null;
      // this.authCadmiumForm.value.partner_segment_id = this.selectedPartnerSegment || null;
      this.authCadmiumForm.value.active = true;
      this.authCadmiumForm.value.integration = true;
      this.authProjectRegistrationPlatform[this.savePlatformName] = this.authCadmiumForm.value;
    }

    if (this.savePlatformName === 'swoogo-registration-platform') {
      const requiredKeys = ['email', 'platform_unique_id'];
      this.fieldMappings = this.visibleFields.reduce((acc, field) => {
        if (field.value?.trim()) acc[field.key] = field.value.trim();
        return acc;
      }, {} as { [key: string]: string });

      // Validate required keys
      for (const key of requiredKeys) {
        if (!this.fieldMappings[key]) {
          this.toastr.error(`${key === 'platform_unique_id' ? 'Platform Unique ID' : 'Email'} is a required field.`);
          throw new Error(`${key} is required in field mapping`);
        }
      }

      if (this.authSwoogoForm.invalid || !this.requireCredentials([
        { field: 'api_key', value: this.authSwoogoForm.value.api_key, label: 'API Key' },
        { field: 'api_secret', value: this.authSwoogoForm.value.api_secret, label: 'API Secret' }
      ])) {
        this.isSwoogoFormValid = false;
        return;
      }

      if (!this.selectedSpeakerSegment && !this.selectedPartnerSegment) {
        this.isSegmentSelect = 'Please Select A Segment';
        return;
      }
      this.authSwoogoForm.value.speaker_segment_id = this.selectedSpeakerSegment || null;
      this.authSwoogoForm.value.partner_segment_id = this.selectedPartnerSegment || null;
      this.authSwoogoForm.value.active = true;
      this.authSwoogoForm.value.integration = true;
      this.authSwoogoForm.value.field_mappings = this.fieldMappings;
      this.authProjectRegistrationPlatform[this.savePlatformName] = this.authSwoogoForm.value;
    }

    if (this.savePlatformName === 'swoogo-sponsors-registration-platform') {
      const requiredKeys = ['email', 'platform_unique_id'];
      this.fieldMappings = this.visibleFields.reduce((acc, field) => {
        if (field.value?.trim()) acc[field.key] = field.value.trim();
        return acc;
      }, {} as { [key: string]: string });

      // Validate required keys
      for (const key of requiredKeys) {
        if (!this.fieldMappings[key]) {
          this.toastr.error(`${key === 'platform_unique_id' ? 'Platform Unique ID' : 'Email'} is a required field.`);
          throw new Error(`${key} is required in field mapping`);
        }
      }
      if (this.authSwoogoSponsorsForm.invalid || !this.requireCredentials([
        { field: 'api_key', value: this.authSwoogoSponsorsForm.value.api_key, label: 'API Key' },
        {
          field: 'api_secret',
          value: this.authSwoogoSponsorsForm.value.api_secret,
          label: 'API Secret'
        }
      ])) {
        this.isSwoogoFormValid = false;
        return;
      }
      if (!this.selectedSpeakerSegment && !this.selectedPartnerSegment) {
        this.isSegmentSelect = 'Please Select A Segment';
        return;
      }
      this.authSwoogoSponsorsForm.value.speaker_segment_id = this.selectedSpeakerSegment || null;
      this.authSwoogoSponsorsForm.value.partner_segment_id = this.selectedPartnerSegment || null;
      this.authSwoogoSponsorsForm.value.active = true;
      this.authSwoogoSponsorsForm.value.integration = true;
      this.authSwoogoSponsorsForm.value.field_mappings = this.fieldMappings;
      this.authProjectRegistrationPlatform[this.savePlatformName] = this.authSwoogoSponsorsForm.value;
    }

    if (this.savePlatformName === 'tech-event') {
      if (this.authTechEventForm.invalid || !this.requireCredential(
        'api_key', this.authTechEventForm.value.api_key, 'API Key'
      )) {
        this.isTechEventFormValid = false;
        return;
      }
      if (!this.selectedPartnerSegment) {
        this.isSegmentSelect = 'Please Select A Segment';
        return;
      }
      this.authTechEventForm.value.partner_segment_id = this.selectedPartnerSegment || null;
      this.authTechEventForm.value.active = true;
      this.authTechEventForm.value.integration = true;
      this.authProjectRegistrationPlatform[this.savePlatformName] = this.authTechEventForm.value;
    }

    if (this.savePlatformName === 'mock-registration-platform') {
      if (this.authMockForm.invalid) {
        this.isMockFormValid = false;
        return;
      }

      if (!this.selectedSpeakerSegment && !this.selectedAttendeeSegment && !this.selectedPartnerSegment) {
        this.isSegmentSelect = 'Please Select At Least One Segment';
        return;
      }

      this.fieldMappings = {
        'email': 'email',
        'platform_unique_id': 'id',
        'first_name': 'firstName',
        'last_name': 'lastName',
        'company': 'company.name',
        'job_title': 'company.jobTitle',
        'phone': 'phone',
        'booth_number': 'boothNumber',
        'sessions': 'sessions',
      };

      this.authMockForm.value.speaker_segment_id = this.selectedSpeakerSegment || null;
      this.authMockForm.value.attendee_segment_id = this.selectedAttendeeSegment || null;
      this.authMockForm.value.partner_segment_id = this.selectedPartnerSegment || null;
      this.authMockForm.value.active = true;
      this.authMockForm.value.integration = true;
      this.authMockForm.value.field_mappings = this.fieldMappings;
      this.authProjectRegistrationPlatform[this.savePlatformName] = this.authMockForm.value;
    }

    if (this.savePlatformName === 'cvent-registration-platform') {
      if (this.authCventForm.invalid || !this.requireCredentials([
        { field: 'client_id', value: this.authCventForm.value.client_id, label: 'Client ID' },
        {
          field: 'client_secret',
          value: this.authCventForm.value.client_secret,
          label: 'Client Secret'
        }
      ])) {
        this.isCventFormValid = false;
        return;
      }
      if (!this.selectedSpeakerSegment) {
        this.isSegmentSelect = 'Please Select A Segment';
      }
      // this.authCventForm.value.speaker_segment_id = this.selectedSpeakerSegment || null;
      this.authCventForm.value.speaker_segment_id = this.selectedSpeakerSegment || null;
      this.authCventForm.value.partner_segment_id = this.selectedPartnerSegment || null;
      this.authCventForm.value.active = true;
      this.authCventForm.value.integration = true;
      this.authProjectRegistrationPlatform[this.savePlatformName] = this.authCventForm.value;
    }

    const params: any = {
      registration_platforms: this.authProjectRegistrationPlatform,
    };
    this.projectStore.dispatch(ProjectUpdate({project: params, projectId: this.projectId}));

    const currentPlatformList = JSON.parse(JSON.stringify(this.registrationPlatformList));
    const project_ids = currentPlatformList[this.currentIndex].project_id ? currentPlatformList[this.currentIndex].project_id.split(',') : [];
    if (!project_ids.includes(this.projectId.toString())) {
      currentPlatformList[this.currentIndex].project_id = currentPlatformList[this.currentIndex].project_id ? currentPlatformList[this.currentIndex].project_id.concat(',', this.projectId.toString()) : this.projectId.toString();
      this.registrationPlatformList = currentPlatformList;
    }
    this._modalService.dismissAll();
    // this.authSwapcardForm.reset();
    this.resetSwapcardForm();
    this.authLineUpNinjaForm.reset();
    this.authTerrapinSalesforceForm.reset();
    this.authSessionBoardForm.reset();
    this.authMapYourShowForm.reset();
    this.authPersonifyA2ZForm.reset();
    this.authCadmiumForm.reset();
    this.authSwoogoForm.reset();
    this.authSwoogoSponsorsForm.reset();
    this.authTechEventForm.reset();
    this.authCventForm.reset();
    this.authMockForm.reset();
    this.isSwapcardFormValid = true;
    this.isLienUpNinjaFormValid = true;
    this.isTerrapinSalesforceFormValid = true;
    this.isSessionBoardFormValid = true;
    this.isMapYourShowFormValid = true;
    this.isCadmiumFormValid = true;
    this.isSwoogoFormValid = true;
    this.isTechEventFormValid = true;
    this.isCventFormValid = true;
    this.isMockFormValid = true;
  }
  get s() {
    return this.authSwapcardForm.controls;
  }

  get l() {
    return this.authLineUpNinjaForm.controls;
  }

  get m() {
    return this.authMapYourShowForm.controls;
  }

  get p() {
    return this.authPersonifyA2ZForm.controls;
  }

  get c() {
    return this.authCadmiumForm.controls;
  }

  get swo() {
    return this.authSwoogoForm.controls;
  }
  get swos() {
    return this.authSwoogoSponsorsForm.controls;
  }
  get te() {
    return this.authTechEventForm.controls;
  }
  get cv() {
    return this.authCventForm.controls;
  }

  get mock() {
    return this.authMockForm.controls;
  }

  onCancel() {
    this._modalService.dismissAll();
    const currentPlatformList = JSON.parse(JSON.stringify(this.registrationPlatformList));
    currentPlatformList[this.currentIndex].active = false;
    this.registrationPlatformList = currentPlatformList;
  }

  formatTime(insertTime) {
    const date = new Date(insertTime);
    insertTime = moment(date, 'YYYY-MM-DD[T]HH[:]mm[:]00[.000Z]');
    if (insertTime.isValid()) {
      return insertTime.format('DD MMM, YYYY h:mm A');
    }
    return null;
  }

  onChecked(index, slug) {
    const projectRegistrationPlatform = (typeof this.project.registration_platforms === 'string' ? JSON.parse(this.project.registration_platforms) : this.project.registration_platforms);
    if (projectRegistrationPlatform && projectRegistrationPlatform.hasOwnProperty(slug)) {
      return projectRegistrationPlatform[slug].active;
    }
    return false;
  }

  isPlatformActive(platform) {
    const reg_platform = this.getRegistrationPlatform();
    if (reg_platform && reg_platform.hasOwnProperty(platform.slug)) {
      return reg_platform[platform.slug].active && reg_platform[platform.slug].integration;
    }
    return false;
  }

  getRegistrationPlatform() {
    return (typeof this.project.registration_platforms === 'string' ? JSON.parse(this.project.registration_platforms) : this.project.registration_platforms);
  }

  getLastSyncTime(slug) {
    const reg_platform = this.getRegistrationPlatform();
    if (reg_platform && reg_platform.hasOwnProperty(slug) && reg_platform[slug].last_sync_time) {
      return `Last sync - ${this.formatTime(reg_platform[slug].last_sync_time)}`;
    } else {
      return null;
    }
  }

  onClickEditPlatform(id) {
    this.router.navigateByUrl(this.routes.registrationPlatformEdit(id));
  }

  copyWebHook(url) {
    const input = document.createElement('textarea');
    input.value = url;
    document.body.appendChild(input);
    input.select();
    document.execCommand('Copy');
    this.toastr.success('Webhook is Copied');
    input.remove();
  }

  isPlatform(slug, prop) {
    if (this.authProjectRegistrationPlatform.hasOwnProperty(slug)) {
      return !!(this.authProjectRegistrationPlatform[slug].hasOwnProperty(prop) && this.authProjectRegistrationPlatform[slug][prop]);
    } else {
      return false;
    }
  }

  onSegmentSelect(event, type) {
    if (event) {
      if (type === 'attendee') {
        this.selectedAttendeeSegment = event.value;
      } else if (type === 'speaker') {
        this.selectedSpeakerSegment = event.value;
      } else if (type === 'partner') {
        this.selectedPartnerSegment = event.value;
      }
    } else {
      if (type === 'attendee') {
        this.selectedAttendeeSegment = null;
      } else if (type === 'speaker') {
        this.selectedSpeakerSegment = null;
      } else if (type === 'partner') {
        this.selectedPartnerSegment = null;
      }
    }
  }

  onSalesForceSegmentSelect(event, type) {
    if (event) {
      if (type === 'otherAttendees') {
        this.selectedSalesForceOtherAttendeeSegment = event.value;
      } else if (type === 'sponsors') {
        this.selectedSalesForceSponsorSegment = event.value;
      } else if (type === 'exhibitor') {
        this.selectedSalesForceExhibitorSegment = event.value;
      } else if (type === 'speaker') {
        this.selectedSalesForceSpeakerSegment = event.value;
      } else if (type === 'guest') {
        this.selectedSalesForceGuestSegment = event.value;
      }
    } else {
      if (type === 'otherAttendees') {
        this.selectedSalesForceOtherAttendeeSegment = null;
      } else if (type === 'sponsors') {
        this.selectedSalesForceSponsorSegment = null;
      } else if (type === 'exhibitor') {
        this.selectedSalesForceExhibitorSegment = null;
      } else if (type === 'speaker') {
        this.selectedSalesForceSpeakerSegment = null;
      } else if (type === 'guest') {
        this.selectedSalesForceGuestSegment = null;
      }
    }
  }

  onMYSSegmentSelect(event, type) {
    if (event) {
      if (type === 'exhibitor') {
        this.selectedMYSExhibitorSegment = event.value;
      } else if (type === 'speaker') {
        this.selectedMYSSpeakerSegment = event.value;
      }
    } else {
      if (type === 'exhibitor') {
        this.selectedMYSExhibitorSegment = null;
      } else if (type === 'speaker') {
        this.selectedMYSSpeakerSegment = null;
      }
    }
  }

  syncStatus() {
    this.registrationPlatformStore.dispatch(InfluencersSyncStatus({syncJobId: this.importJobId}));
  }

  isImportDataFilled() {
    return this.importData && Object.keys(this.importData).length > 0;
  }

  importDataTableColumns() {
    return this.importData['columns'];
  }

  showSyncLogs() {
    const modelRef = this._modalService.open(this.logsTable, {
      centered: false,
      size: 'xl',
      keyboard: false,
      backdrop: 'static',
      windowClass: 'api-platform-auth-modal',
    });
    modelRef.result.then((result) => {
    }, (reason) => {
    });
  }

  showPreviousSyncLogs(id) {
    const data = {
      campaign_id: '',
      influencer_type_id: '',
      project_id: this.projectId,
      action: 'sync',
      registration_platform_id: id
    };
    const modelRef: any = this._modalService.open(TaskLogsComponent, {
      centered: false,
      size: 'xl',
      keyboard: true
    });
    modelRef.componentInstance.data = data;
    modelRef.result.then((result) => {
    }, (reason) => {
    });
  }

  getInfluencerTypes() {
    this.influencersStore.dispatch(InfluencersTypeList());
  }

  get influencerKeysFormGroup() {
    return this.authSwapcardForm.get('influencer_keys') as UntypedFormArray;
  }

  addInfluencerKeysButtonClick(): void {
    if (!this.authSwapcardForm.value.influencer_keys?.length || (this.authSwapcardForm.value.influencer_keys?.length && !this.allObjectsHaveValues(this.authSwapcardForm.value.influencer_keys))) {
      this.isSegmentSelect = '';
      this.isSwapcardFormValid = false;
      return;
    }
    this.influencerKeysFormGroup.push(this.addInfluencerKeysGroup());
  }

  addInfluencerKeysGroup(): UntypedFormGroup {
    return this.formBuilder.group({
      name: [''],
      category: [null],
      segmentId: [null]
    });
  }

  swapcardSegmentOptionsForCategory(category: string) {
    if (category === 'attendee') {
      return this.attendeeSegments;
    }
    if (category === 'speaker') {
      return this.speakerSegments;
    }
    if (category === 'partner') {
      return this.partnerSegments;
    }
    return [];
  }

  swapcardSegmentFieldLabel(category: string) {
    if (category === 'attendee') {
      return 'Select Attendee Segment';
    }
    if (category === 'speaker') {
      return 'Select Speaker Segment';
    }
    if (category === 'partner') {
      return 'Select Partner Segment';
    }
    return 'Segment';
  }

  swapcardSegmentPlaceholder(category: string) {
    if (!category || category === 'null') {
      return 'Select a category first';
    }
    return this.swapcardSegmentFieldLabel(category);
  }

  onSwapcardKeyCategorySelect(event: { value?: number | string } | null, index: number) {
    const grp = this.influencerKeysFormGroup.at(index);
    if (!grp) {
      return;
    }
    const value = event?.value != null ? event.value : null;
    grp.patchValue({ category: value, segmentId: null });
  }

  onSwapcardKeySegmentSelect(event: { value?: number | string } | null, index: number) {
    const grp = this.influencerKeysFormGroup.at(index);
    if (!grp) {
      return;
    }
    const value = event?.value != null ? event.value : null;
    grp.patchValue({ segmentId: value });
  }

  isCredentialFieldConfigured(field: string): boolean {
    const status = (this.project?.registration_credentials || []).find(
      (item: any) => item.platform === this.savePlatformName
    );
    return !!status?.configured_fields?.includes(field);
  }

  private hasCredential(field: string, value: unknown): boolean {
    return (value != null && String(value).trim() !== '')
      || this.isCredentialFieldConfigured(field);
  }

  private requireCredential(field: string, value: unknown, label: string): boolean {
    if (this.hasCredential(field, value)) {
      return true;
    }
    this.toastr.error(`${label} is required.`);
    return false;
  }

  private requireCredentials(
    credentials: Array<{ field: string; value: unknown; label: string }>
  ): boolean {
    const missing = credentials.filter(({ field, value }) => !this.hasCredential(field, value));
    if (!missing.length) {
      return true;
    }
    this.toastr.error(`${missing.map(({ label }) => label).join(' and ')} required.`);
    return false;
  }

  private withSafeRegistrationConfiguration(project: any): any {
    return {
      ...project,
      registration_platforms: project.registration_platform_configuration
        || project.registration_platforms
        || {}
    };
  }

  removeInfluencerKeysButtonClick(index: number): void {
    this.influencerKeysFormGroup.removeAt(index);
  }

  ngOnDestroy() {
    this.unsubscriber.next(undefined);
    this.unsubscriber.complete();
  }
}
